<template>
  <el-dialog
    title="批量打印"
    :visible.sync="dialogFormVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog">
    <div ref="print1" >
    <div v-for="(item,index) in tabledata">
    <CstagreementPrint ref="CstagreementPrint" :printbaibao="printbaibao" :printtype="printtype"></CstagreementPrint>
    <P style='page-break-after:always'>&nbsp;</P>
    </div>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="info" @click="print1(1)">打印</el-button>
      <el-button type="info" @click="print1(2)">打印(无价格)</el-button>
      <el-button type="info" @click="print1(3)">拣货单</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import CstagreementPrint from './CstagreementPrint';
  import {save} from '@/api/order/printlog';

    export default {
      name: "CstagreementBatchPrint",
      data() {
        return {
          tabledata:[],
          dialogFormVisible: false,
          printtype: 1,//1=打印(带价) 2=打印(无价格) 3=拣货单
        }
      },
      props: {
        printbaibao: {
          default: false
        },
      },
      methods: {
        /**
         * 批量打印
         * @param tabledata 订单列表（含 unitguid/erpserial/invoicesource）
         * @param printtype 1=打印(带价) 2=打印(无价格) 3=拣货单
         */
        show(tabledata, printtype) {
          this.tabledata = tabledata || [];
          this.printtype = printtype || 1;
          this.dialogFormVisible = true;
          this.$nextTick(() => {
            if (!this.$refs.CstagreementPrint) return;
            for (let i in this.tabledata) {
              this.$refs.CstagreementPrint[i].printtype = this.printtype;
              this.$refs.CstagreementPrint[i].initData(this.tabledata[i])
            }
          })
        },
        print1(printtype) {
          if(this.tabledata.length==0)
            return;
          this.printtype = printtype || 1;
          //显式设置每个子组件打印类型+价格显示（直接改data，响应式即时生效，不依赖prop链路）
          for (let i in this.$refs.CstagreementPrint) {
            var child = this.$refs.CstagreementPrint[i];
            if (!child) continue;
            child.printtype = this.printtype;
            if (this.printtype == 2) {
              child.printDisplay = false;//无价格强制隐藏
            } else if (this.printtype == 1) {
              child.printDisplay = child._defaultPrintDisplay != null ? child._defaultPrintDisplay : child.printDisplay;//恢复默认
            }
          }
          //等待vue渲染切换后再打印（否则打印预览还是旧内容）
          this.$nextTick(() => {
            this.$print(this.$refs.print1)
            var erps='';
            for(let i in this.tabledata){
              erps+=this.tabledata[i].erpserial+';';
            }
            save({erpserial: erps, invoicesource: this.tabledata[0].invoicesource, printtype: this.printtype}).then(response => {
              if (response.data.code == 0) {
                //不关闭弹窗，可能多次打印
                this.$emit("bindGrid");//刷新父页面
              }
            })
          })
        },
      },
      components: {
        CstagreementPrint,
      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/testorder/cstagreement/CstagreementBatchPrint.vue